import { destroyCookie, parseCookies, setCookie } from 'nookies';
import { ServerSideProps } from 'core/funnel/entities';
import { CookieOptions } from '../../entities';
import { CookiesService } from './CookiesService';

export class CookiesServerService implements CookiesService {
  private options: CookieOptions;
  private serverContext?: ServerSideProps;

  constructor(options: CookieOptions = {}, serverContext?: ServerSideProps) {
    this.options = options;
    this.serverContext = serverContext;
  }

  set(key: string, value: string, options: CookieOptions = {}) {
    if (!this.serverContext) return;

    const mergedOptions = { ...this.options, ...options };
    setCookie(this.serverContext, key, value, mergedOptions);
  }

  get(key: string): string | undefined {
    if (!this.serverContext) return;

    const cookies = parseCookies(this.serverContext);
    return cookies[key];
  }

  getAll(): Record<string, string> | undefined {
    if (!this.serverContext) return;

    return parseCookies(this.serverContext);
  }

  remove(key: string, options: CookieOptions = {}) {
    if (!this.serverContext) return;

    const mergedOptions = { ...this.options, ...options };
    destroyCookie(this.serverContext, key, mergedOptions);
  }
}
